<div class="modal-container" role="dialog" aria-modal="true" tabindex="1">
  <!-- Screen reader announcement for hover -->
  <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{hoverAnnouncement}}</div>
  
  <div class="email-header">
    <span class="title">{{titleStr}}</span>
    <button class="close" 
          (click)="onClose()" 
          (keydown.enter)="onClose(); $event.preventDefault()" 
          (keydown.space)="onClose(); $event.preventDefault()" 
          (mouseenter)="announceCloseButton()"
          (mouseleave)="clearAnnouncement()"
          (focus)="announceCloseButton()"
          (blur)="clearAnnouncement()"
          tabindex="3"
          type="button"
          aria-label="Close"
          title="Close button">
    </button>
  </div>

  <div *ngIf="showToast" class="toast-container">
        <div [ngClass]="['toast-message', toastType === 'success' ? 'toast-success' : 'toast-error']">
            <div class="toast-content">
                <div class="toast-text">
                    <div class="toast-title" *ngIf="toastTitle">{{ toastTitle }}</div>
                    <div class="toast-message-text">{{ toastMessageText }}</div>
                </div>
                <span class="material-symbols-outlined f-24 cursor-pointer" 
                  tabindex="-1"
                  (click)="closeToast()" 
                  (keypress)="closeToast()"
                  title="Close">close</span>
            </div>
        </div>
  </div>

  <div class="email-inner-panel">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 formField" *ngIf="type === 'primaryEmail' || type === 'recoveryEmail'">
        <label for="email">{{emailLabel}}<span class="requiredField" *ngIf="!disableFlag">*</span>
          <span class="ml-1 tooltip-icon" style="position:relative;" (mouseenter)="emailTooltip = true" (mouseleave)="emailTooltip = false">
            <span class="material-symbols-outlined f-16" 
                  #firstFocusableElement
                  tabindex="1" 
                  role="button"
                  aria-label="Information about email"
                  (keydown.enter)="emailTooltip = !emailTooltip"
                  (keydown.space)="emailTooltip = !emailTooltip; $event.preventDefault()"
                  (focus)="emailTooltip = true"
                  (blur)="emailTooltip = false">info</span>
            <span *ngIf="emailTooltip" class="material-symbols-outlined inverted-arrow inverted-arrow-s">arrow_drop_down</span>
            <div *ngIf="emailTooltip" class="email-tooltip-box">
              <div class="ssn-tooltip-polygon"></div>
              <div id="error_updateContact_G0002" class="email-tooltip-frame" (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                {{genericMessage['G0002']}}
              </div>
            </div>
          </span>
        </label>
        <input 
          tabindex="2" 
          placeholder="user@example.com" 
          type="email" 
          id="inputfield_updateContact_email" 
          maxlength="255"
          [(ngModel)]="newEmail" 
          [disabled]="disableFlag"
          (focus)="onEmailFocus()"
          />
        <div id="error_updateContact_invalidEmail" role="alert" *ngIf="invalidEmailFormate" class="text-danger mt-1 err-font">
          {{ errorMessage }}
        </div>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-12 formField" *ngIf="type === 'phoneNumber' || type === 'altPhoneNumber'">
        <label for="phone">New Phone Number<span class="requiredField">*</span></label>
        <input 
          #firstFocusableElement
          maxlength="17" 
          [disabled]="isVarificationSent" 
          tabindex="1" type="tel" 
          id="inputfield_updateContact_phoneNumber" 
          [(ngModel)]="displayPhone" 
          placeholder="Enter Phone Number"
          (focus)="onPhoneFocus()"
          (blur)="onPhoneBlur()"
        />
        <div id="error_updateContact_invalidPhnNumber" role="alert" class="text-danger mt-1 err-font" *ngIf="invalidPhoneNumberFormate">
          {{ errorMessage }}
        </div>
      </div>
    </div>
    <div class="row" *ngIf="showSecond">
      <div class="otp-section">
        <div class="otp-label">
          <label>Verification Code</label>
          <span class="requiredField">*</span>
        </div>

        <div class="otp-input-container">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="0" [(ngModel)]="otp[0]" (focus)="onOtpFocus()" (blur)="onOtpBlur()" #otpFirst>
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="1" [(ngModel)]="otp[1]" (focus)="onOtpFocus()" (blur)="onOtpBlur()">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="2" [(ngModel)]="otp[2]" (focus)="onOtpFocus()" (blur)="onOtpBlur()">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="3" [(ngModel)]="otp[3]" (focus)="onOtpFocus()" (blur)="onOtpBlur()">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="4" [(ngModel)]="otp[4]" (focus)="onOtpFocus()" (blur)="onOtpBlur()">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="5" [(ngModel)]="otp[5]" (focus)="onOtpFocus()" (blur)="onOtpBlur()">
        </div>

        <div id="error_updateContact_otpInput" *ngIf="showOtpError || (otpTouched && !fieldFocus && otp.join('').length === 0)" class="text-danger err-font">
          {{ errorMessage }}
        </div>

        <div class="timer-section">
          <button class="resend-button" (click)="resendOtp()" [disabled]="isOtpResendButtonDisabled">Resend Code</button>
          <div class="timer" [ngClass]="{'timer-warning': timeRemaining <= 15}" *ngIf="timerActive">
            {{ timerDisplay }}
          </div>
          <div class="timer" [ngClass]="{'timer-warning': timeRemaining <= 15}" *ngIf="getCurrentFieldRemainingTime() > 0">
            {{ getCurrentFieldBlockTimeDisplay() }}
          </div>
        </div>

      </div>
    </div>
    <div class="email-footer">

      <button 
        type="button" 
        class="btn btn-primary fullWidth"
        *ngIf="!showSecond && (type === 'primaryEmail' || type === 'recoveryEmail')" 
        (click)="sendVerification()"
        [disabled]="isEmailSendButtonDisabled"
        [ngClass]="{'disabled': isEmailSendButtonDisabled}"
        id="btn_updateContact_sendEmailVerification"
        tabindex="4"
      >
        Send Verification Code
      </button>
      
      <button 
        type="button" 
        class="btn btn-primary fullWidth" 
        *ngIf="!showSecond && (type === 'phoneNumber' || type === 'altPhoneNumber')"
        (click)="sendVerification()"
        [disabled]="isPhoneSendButtonDisabled"
        [ngClass]="{'disabled': isPhoneSendButtonDisabled}"
        id="btn_updateContact_sendPhoneNumberVerification"
        tabindex="4"
      >
        Send Verification Code
      </button>

      <button 
        type="button" 
        class="btn btn-primary fullWidth" 
        *ngIf="showSecond" 
        (click)="verifyOtp()"
        [disabled]="isOtpVerifyButtonDisabled"
        [ngClass]="{'disabled': isOtpVerifyButtonDisabled}"
        id="btn_updateContact_verifyOtp"
        tabindex="4"
      >
        {{verifyUpdate}}
      </button>

    </div>
  </div>